/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LegalTransition } from './LegalTransition';
import {
    LegalTransitionFromJSON,
    LegalTransitionFromJSONTyped,
    LegalTransitionToJSON,
    LegalTransitionToJSONTyped,
} from './LegalTransition';

/**
 * 
 * @export
 * @interface FindAdmissionStatusOptions200Response
 */
export interface FindAdmissionStatusOptions200Response {
    /**
     * Map of lead_id to its admission-status options.
     */
    data?: { [key: string]: Array<LegalTransition>; };
}

/**
 * Check if a given object implements the FindAdmissionStatusOptions200Response interface.
 */
export function instanceOfFindAdmissionStatusOptions200Response(value: object): value is FindAdmissionStatusOptions200Response {
    return true;
}

export function FindAdmissionStatusOptions200ResponseFromJSON(json: any): FindAdmissionStatusOptions200Response {
    return FindAdmissionStatusOptions200ResponseFromJSONTyped(json, false);
}

export function FindAdmissionStatusOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAdmissionStatusOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function FindAdmissionStatusOptions200ResponseToJSON(json: any): FindAdmissionStatusOptions200Response {
    return FindAdmissionStatusOptions200ResponseToJSONTyped(json, false);
}

export function FindAdmissionStatusOptions200ResponseToJSONTyped(value?: FindAdmissionStatusOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

